import { api, BASE_URL, getToken } from './client';

/**
 * Payment preparation + pain.001 export (banking cycle close, 2026-09-12).
 * Outstanding amounts come from the reconciliation read model; the export is
 * READ-ONLY (nothing is persisted — the file goes to the bank).
 */

export interface UnpaidInvoiceDto {
  invoiceJournalId: number;
  documentNumber: string;
  date: string;
  supplierPersonId: number | null;
  supplierName: string;
  supplierBankAccount: string | null;
  supplierBankName: string | null;
  outstandingAmount: number;
  currencyCode: string;
  content: string | null;
}

export interface Pain001Payment {
  invoiceJournalId: number;
  amount: number;
  customBankAccount?: string | null;
  description?: string | null;
  purposeCode?: string | null;
}

export const paymentExportApi = {
  unpaidInvoices: () => api.get<UnpaidInvoiceDto[]>('/payment-export/unpaid-invoices'),

  /**
   * Generate the pain.001 XML for the selected payments and download it as a
   * blob (POST body → forced file download, the findings-export pattern).
   */
  generate: async (
    bankAccountId: number,
    payments: Pain001Payment[],
    executionDate?: string,
  ): Promise<void> => {
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    const token = getToken();
    if (token) headers['Authorization'] = `Bearer ${token}`;
    const response = await fetch(`${BASE_URL}/payment-export/generate`, {
      method: 'POST',
      headers,
      credentials: 'include',
      body: JSON.stringify({ bankAccountId, executionDate: executionDate ?? null, payments }),
    });
    if (!response.ok) {
      const text = await response.text().catch(() => '');
      throw new Error(text || `Eksportas nepavyko (${response.status})`);
    }
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    try {
      const disposition = response.headers.get('Content-Disposition') ?? '';
      const match = disposition.match(/filename="?([^";]+)"?/);
      const a = document.createElement('a');
      a.href = url;
      a.download = match?.[1] ?? `mokėjimai-${new Date().toISOString().slice(0, 10)}.xml`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } finally {
      URL.revokeObjectURL(url);
    }
  },
};
